// Main Components
import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"
import "./infographic.scss"

const Infographic = ({headline, headlineBold}) => {

  return (
    // <div className="bg-secondary" style={{ height: '450px' }}>
    //   <h2 className="display-5 m-5 p-5 text-center">
    //     This is the Infographic section
    //   </h2>
    // </div>
    <section>
    <div id="infographic-container"className="infographic-container d-flex align-items-center py-5">
      <div className="container">
      <div className="row">
        {/* Infographic */}
        <div className="col-sm-12 col-md-12  col-lg-6 text-center ">
          <div className="row mx-5">
            <div className="col border-bottom py-3 py-sm-2 infographic-icons">
                <StaticImage
                src="../images/online-page-views.svg"
                quality={100}
                alt="Online Page Views"
                />
                <h2 className="pt-2"><strong>1.3 mil</strong> <span>+</span></h2>
                <p>Page Views / mo</p>
            </div>
            <div className="col border-bottom border-start py-3 py-sm-2 infographic-icons">
                <StaticImage
                  src="../images/website-visitors.svg"
                  quality={100}
                  alt="Website Visitors"
                />
                <h2 className="pt-2"><strong>10 mil</strong> <span>+</span></h2>
                <p>Website Visitors / yr</p>
            </div>
          <div className="w-100"></div>
            <div className="col py-4 infographic-icons">
              <StaticImage
                src="../images/website-blog-pages.svg"
                quality={100}
                alt="Website Blog Images"
              />
              <h2 className="pt-2"><strong>1 mil</strong> <span>+</span></h2>
              <p>Published Words / mo</p>
            </div>
            <div className="col border-start py-4 infographic-icons">
              <StaticImage
                src="../images/booked-appointments.svg"
                quality={100}
                alt="Booked Appointments"
              />
              <h2 className="pt-2"><strong>171k</strong> <span>+</span></h2>
              <p>Appointment Requests / yr</p>
            </div>
          </div>
        </div>
        {/* text */}
        <div className="col-sm-12 col-md-12  col-lg-6 text-center  d-flex align-items-center infographic-headline">
          <div className="container">
            <h2 className="mx-0 px-0 display-6"><strong>{headlineBold}</strong> {headline}</h2>
          </div>
        </div>

      </div>
    </div>
    </div>
    </section>
  )
}

export default Infographic
